import CloseButtonDialog from "App/components/CloseButtonDialog";
import React, { useState, useEffect, useContext, useLayoutEffect } from 'react';
import { LayoutContext } from 'App/Layout/store'
import { Grid, InputLabel, List, ListItem, ListItemText, TextField, Paper, FormLabel, FormControl, Input, InputAdornment, IconButton, Divider } from "@material-ui/core";
import Axios from "axios";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from "@material-ui/core/styles";
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    progress: {
        padding: theme.spacing.unit * 2,
    },
});

function Index(props) {

    const { classes } = props;

    const layoutContext = useContext(LayoutContext);
    const [cargando, setCargando] = useState(false);

    function CambiarEmpresa(empresa) {
        if(empresa.Rut != layoutContext.state.datosEmpresa.Rut){
        var conf = window.confirm("¿Desea cambiar de empresa?");
        if (conf) {
            cookies.set('empresa', empresa.Rut, { path: '/' });
            window.location.reload();
        }
        }else{
            handleToggleModal();
        }
    }
    const handleToggleModal = () => {
        layoutContext.dispatch({ type: "toggleModalEmpresas" });
    }

    useEffect(()=>{
        if(layoutContext.state.openModalEmpresas){
            setCargando(true);
            axios.get("/api/cuenta/empresas").then(listado => {
                layoutContext.dispatch({ type: "setListadoEmpresas", listado });
                setCargando(false);
            }).catch(e => console.error(e))
        }
    },[layoutContext.state.openModalEmpresas])

    // const handleprueba = () => {
    //     prueba()
    // };
    const content = cargando ? <div className={classes.progress}><CircularProgress disableShrink /></div> : (
        <form>
            <Typography variant="h6">¿Con qué empresa quieres trabajar?</Typography>
            <Grid container spacing={0}>
                <List component="nav">
                {layoutContext.state.listadoEmpresas.map(emp => {
                    return(
                        <ListItem button onClick={(e) => { e.preventDefault(); CambiarEmpresa(emp); }}>
                            <ListItemText primary={emp.RazonSocial+" ("+emp.Rut+"-"+emp.Dv+")"} />
                        </ListItem>
                    )
                })}
                </List>
            </Grid>
        </form>
    )
    return (
        <div>
            <CloseButtonDialog open={layoutContext.state.openModalEmpresas} onClose={handleToggleModal} closeButton title="Mis Empresas" content={content} size="md" />
        </div>
    );
}
export default withStyles(styles)(React.memo(Index));
